module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadData),
      expression: "loadData"
    }],
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "id": "contacts-index",
      "infinite-scroll-distance": "10"
    }
  }, [_c('div', {
    staticClass: "header-with-action"
  }, [_c('h1', {
    staticClass: "pull-left"
  }, [_vm._v("Base de Contatos")]), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "dropdown dropdown-export-menu"
  }, [_vm._m(0), _c('ul', {
    staticClass: "dropdown-menu dropdown-export"
  }, [_c('li', {
    staticClass: "btn export",
    on: {
      "click": function($event) {
        return _vm.exportContacts('all_base')
      }
    }
  }, [_vm._v("Exportar Base de Contatos")]), _c('li', {
    staticClass: "btn export",
    on: {
      "click": function($event) {
        return _vm.exportContacts('filters')
      }
    }
  }, [_vm._v("Exportar Resultados do Filtro")])])]), _c('div', {
    staticClass: "dropdown pull-right"
  }, [(!_vm.current_user.isMonitoringManager()) ? _c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _vm._v("Inserir Contatos")]) : _vm._e(), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/contatos/importar/manualmente'
    }
  }, [_vm._v("Inserir manualmente")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": '/contatos/importar/csv'
    }
  }, [_vm._v("Importar CSV")])], 1)])])])]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "tab-list",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.leadsRedirect()
      }
    }
  }, [_vm._v("Contatos")])]), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.groupsRedirect()
      }
    }
  }, [_vm._v("Grupos")])]), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.businessRedirect()
      }
    }
  }, [_vm._v("Empresas")])])])]), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "contacts-tab",
      "role": "tabpanel"
    }
  }, [_c('contact-list', {
    attrs: {
      "contacts": _vm.contacts,
      "selected_contact_ids": _vm.selected_contact_ids,
      "unselected_contact_ids": _vm.unselected_contact_ids,
      "count_all_contacts": _vm.count_all_contacts,
      "count_page_contacts": _vm.count_page_contacts,
      "view_mode": _vm.contactListViewModes().index,
      "filters": _vm.filters
    },
    on: {
      "contact-update": _vm.updateContact,
      "reengage-contact": _vm.reengage,
      "contact-recipient-update": _vm.updateContactRecipient,
      "contact-destroy": _vm.openDestroyContactConfirmationModal,
      "filter": _vm.filter,
      "contact-selected": _vm.loadSelectedContactsList,
      "user-selected": _vm.callPrepareChangeResponsability
    }
  })], 1)]), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.fetching
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Sem mais resultados")])], 1), _c('go-to-top'), _c('reactivate-recipient-modal', {
    attrs: {
      "contact": _vm.schedule_reactivation_contact
    }
  }), _c('confirm-modal', {
    attrs: {
      "id": "confirm-remove-contact",
      "title": "Excluir contato",
      "confirm_text": "Sim, excluir",
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.callDestroyContact
    }
  }, [_c('br'), _c('div', {
    staticClass: "text-center"
  }, [_c('div', [_vm._v("Confirma exclusão do contato abaixo?")]), _c('strong', {
    staticClass: "dark-red-color"
  }, [_vm._v(_vm._s(_vm.selected_contact.full_name))])])]), _c('confirm-modal', {
    attrs: {
      "id": "confirm-remove-contacts",
      "title": "Excluir contatos selecionados",
      "confirm_text": "Sim, excluir",
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.callDestroyContacts
    }
  }, [_c('br'), _c('div', {
    staticClass: "text-center"
  }, [(_vm.count_selected_contacts > 1) ? _c('div', [_vm._v("Confirma exclusão de " + _vm._s(_vm.count_selected_contacts) + " contatos selecionados?")]) : _c('div', [_vm._v("Confirma exclusão de " + _vm._s(_vm.count_selected_contacts) + " contato selecionado?")])])]), _c('change-responsability-modal', {
    on: {
      "confirm-modal-confirm": _vm.confirmChangeResponsability
    }
  }), _c('create-tag-modal'), _c('task-modal-form')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("../../assets/images/icons/exportar_icon.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c2be2e7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/leads.vue
// module id = 1054
// module chunks = 1